export default __webpack_public_path__ + "static/media/PUMA_SAFARI_MOBILE.b03afc06.mp4";